import { Component, inject } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { ClipboardService } from 'src/app/utils/copy-to-clipboard-util';
import { ModalBaseComponent } from 'src/app/shared/components/modal-base/modal-base.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-show-api-key-modal',
  imports: [TranslateModule, ModalBaseComponent, CommonModule],
  templateUrl: './show-api-key-modal.component.html',
})
export class ShowApiKeyModalComponent {
  protected translate = inject(TranslateService);
  protected dialogRef = inject(DialogRef);
  protected data = inject(DIALOG_DATA);
  protected clipboardService = inject(ClipboardService);
}
